<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_sys_logs"
        :columns="columns"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'ServerLogs',
  components: {
    TableWrapper
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/logs'
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '发生时间', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择发生日期...', type: 'dateranger' },
          { label: '用户', placeholder: '请输入用户姓名...', name: 'user', width: 'auto', type: 'input' },
          { label: '手机号', placeholder: '请输入用户手机号...', name: 'mobile', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index' },
        { title: '用户', align: 'center', key: 'operator', sortable: true, width: 100, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.operator || '---')
          }
        },
        { title: '手机号', align: 'center', key: 'mobile', sortable: true, width: 120, ellipsis: true, tooltip: true },
        { title: '调用模块', align: 'center', key: 'module', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.module || '---')
          }
        },
        { title: '操作内容', align: 'center', key: 'operation', sortable: true, width: 240, ellipsis: true, tooltip: true },
        { title: '调用方法', align: 'center', key: 'method', sortable: true, ellipsis: true, tooltip: true },
        { title: '参数', align: 'center', key: 'params', ellipsis: true, tooltip: true },
        { title: '时间(ms)', align: 'center', key: 'exec_time', sortable: true, width: 120, ellipsis: true, tooltip: true },
        { title: 'IP', align: 'center', key: 'ip', sortable: true, width: 120, ellipsis: true, tooltip: true },
        { title: '发生时间', align: 'center', key: 'time', sortable: true, width: 160, ellipsis: true, tooltip: true }
      ]
    }
  },
  methods: {
  }
}
</script>

